export default __webpack_public_path__ + "static/media/undraw_authentication_fsn5.53727fe7.svg";